import React from 'react';
import { Clock, Users, Star, CheckCircle, Play, Lock } from 'lucide-react';

const CoursesPage = () => {
  const courses = [
    {
      id: 1,
      title: "ADHD Productivity Mastery",
      description: "Learn science-backed productivity systems designed specifically for ADHD brains. Transform how you work and accomplish your goals.",
      duration: "4 weeks",
      lessons: 24,
      level: "Beginner",
      price: 99,
      rating: 4.9,
      students: 1250,
      image: "🎯",
      popular: true
    },
    {
      id: 2,
      title: "Time Management for ADHD",
      description: "Overcome time blindness and master your schedule. Practical techniques that actually work for the ADHD brain.",
      duration: "3 weeks",
      lessons: 18,
      level: "All Levels",
      price: 79,
      rating: 4.8,
      students: 890,
      image: "⏰"
    },
    {
      id: 3,
      title: "ADHD and Relationships",
      description: "Build stronger connections and communicate effectively. Navigate relationships with understanding and empathy.",
      duration: "5 weeks",
      lessons: 30,
      level: "Intermediate",
      price: 129,
      rating: 4.9,
      students: 670,
      image: "💞"
    },
    {
      id: 4,
      title: "Financial Freedom with ADHD",
      description: "Master your money despite impulse spending and financial chaos. Build systems that work automatically.",
      duration: "4 weeks",
      lessons: 22,
      level: "All Levels",
      price: 89,
      rating: 4.7,
      students: 540,
      image: "💰"
    },
    {
      id: 5,
      title: "ADHD-Friendly Health & Wellness",
      description: "Create sustainable health habits that fit your ADHD lifestyle. Nutrition, exercise, and sleep strategies.",
      duration: "6 weeks",
      lessons: 36,
      level: "Beginner",
      price: 109,
      rating: 4.8,
      students: 780,
      image: "🏥"
    },
    {
      id: 6,
      title: "Advanced Focus Techniques",
      description: "Harness hyperfocus and eliminate distractions. Deep work strategies for maximum productivity.",
      duration: "3 weeks",
      lessons: 15,
      level: "Advanced",
      price: 149,
      rating: 4.9,
      students: 420,
      image: "🧠"
    },
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-teal-600 to-emerald-600 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">ADHD Courses</h1>
          <p className="text-xl opacity-90">Transform your life with expert-led courses designed for ADHD minds</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {courses.map((course) => (
                <div key={course.id} className={`bg-white rounded-xl shadow-lg overflow-hidden ${course.popular ? 'ring-2 ring-teal-500' : ''}`}>
                  {course.popular && (
                    <div className="bg-teal-500 text-white text-center py-2 font-semibold text-sm">
                      Most Popular
                    </div>
                  )}
                  <div className="h-40 bg-gradient-to-br from-teal-100 to-emerald-100 flex items-center justify-center">
                    <div className="text-6xl">{course.image}</div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-sm text-teal-600 font-semibold">{course.level}</span>
                      <div className="flex items-center">
                        <Star className="w-4 h-4 text-amber-500 fill-current" />
                        <span className="ml-1 text-sm font-semibold">{course.rating}</span>
                      </div>
                    </div>
                    <h3 className="text-2xl font-bold mb-3">{course.title}</h3>
                    <p className="text-gray-600 mb-4">{course.description}</p>
                    
                    <div className="flex items-center gap-4 mb-4 text-sm text-gray-500">
                      <div className="flex items-center">
                        <Clock size={16} className="mr-1" /> {course.duration}
                      </div>
                      <div className="flex items-center">
                        <Users size={16} className="mr-1" /> {course.students} students
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="mr-1" /> {course.lessons} lessons
                      </div>
                    </div>

                    <div className="flex items-center justify-between">
                      <div className="text-3xl font-bold text-teal-600">${course.price}</div>
                      <button className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition flex items-center">
                        <Play size={18} className="mr-2" /> Enroll Now
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 text-center">
              <p className="text-lg text-gray-600 mb-4">
                Not sure which course is right for you? Take our free assessment!
              </p>
              <button className="border-2 border-teal-600 text-teal-600 px-8 py-3 rounded-lg font-semibold hover:bg-teal-50 transition">
                Take Free Assessment
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CoursesPage;